<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields" foot-clone>
      <template #thead-top="data">
        <b-tr>
          <b-th colspan="12" style="text-align: center"></b-th>
          <b-th colspan="5" style="text-align: center">日常扣款</b-th>
          <b-th colspan="3" style="text-align: center">收费考核</b-th>
          <b-th colspan="2" style="text-align: center"></b-th>
          <b-th colspan="6" style="text-align: center">代扣款项</b-th>
          <b-th colspan="1" style="text-align: center"></b-th>
        </b-tr>
      </template>
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(judgeName)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.judgeName)">{{ data.item.judgeName }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
      <template v-slot:foot()="scope">
        <div class="text-nowrap" :style="{textAlign:'center'}">-</div>
      </template>
      <template v-slot:foot(judgeName)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">面试评分</div>
      </template>
      <template v-slot:foot(score)="data">
        <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(items, 'score') }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";

export default {
  name: "HrSalaryCalcActualDetail",
  data() {
    return {
      fields: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'employeeName', label: '姓名', width: '120px'},
        {key: 'corpName', label: '公司名称', width: '120px'},
        {key: 'orgName', label: '部门名称', width: '120px'},
        {key: 'stationName', label: '岗位名称', width: '120px'},
        {key: 'feeCorpName', label: '费用承担公司', width: '120px'},
        {key: 'itemsName', label: '所属项目', width: '120px'},
        {key: 'monthSalary', label: '基本工资', width: '120px'},
        {key: 'bonusFee', label: '奖金', width: '120px'},
        {key: 'wealFee', label: '福利费用', width: '120px'},
        {key: 'extraFee', label: '加班费', width: '120px'},
        {key: 'totalFee', label: '小计', width: '120px'},
        {key: 'absenceFee2', label: '事假', width: '120px'},
        {key: 'absenceFee3', label: '病假', width: '120px'},
        {key: 'absenceFee99', label: '其他', width: '120px'},
        {key: 'cutFee', label: '考核扣款', width: '120px'},
        {key: 'absenceFee', label: '扣款小计', width: '120px'},
        {key: 'cutFee1', label: '扣款', width: '120px'},
        {key: 'cutFee2', label: '奖励', width: '120px'},
        {key: 'cutFee3', label: '返还', width: '120px'},
        {key: 'theoryFee', label: '应付小计', width: '120px'},
        {key: 'corpFee', label: '公司代缴', width: '120px'},
        {key: 'pensionFee', label: '养老保险金', width: '120px'},
        {key: 'medicFee', label: '医疗保险金', width: '120px'},
        {key: 'loseFee', label: '失业保险金', width: '120px'},
        {key: 'gjjFee', label: '住房公积金', width: '120px'},
        {key: 'taxFee', label: '个所税', width: '120px'},
        {key: 'dkFee', label: '小计', width: '120px'},
        {key: 'actualFee', label: '实发金额', width: '120px'},
      ],
      items: [],
      columnLength: 0,
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value));
        }
        return total;
      }, 0).div(this.items.length).toFixed(0, Decimal.ROUND_HALF_UP);
    }
  }
}
</script>

<style scoped>
.row-center {
  display: flex;
  justify-content: center;
}
</style>
